import { useEffect, useState } from "react";
import { FeatureConfigLuckyOrangeSiteId, FeatureLuckyOrange } from "../app/consts";
import { useAuth } from "swyft-react-core";
import { useConfig } from "./config/ConfigContext";
import { getConsentForCategory } from "./Termly";

class LuckyOrangeClass {
  initialized = false;

  initialize(siteId: string) {
    // console.log("LuckyOrange Init");
    if (this.initialized) {
      return;
    }

    if (!siteId) {
      console.log("no LuckOrange ID");
      return;
    }

    const script = document.createElement("script");

    script.src = `https://tools.luckyorange.com/core/lo.js?site-id=${siteId}`;
    script.async = true;
    script.defer = true;

    document.head.insertBefore(script, document.head.childNodes[0]);
    this.initialized = true;
  }

  // eslint-disable-next-line class-methods-use-this
  push(...args: any) {
    if (!(window as any)._loq) {
      (window as any)._loq = [];
    }

    (window as any)._loq.push(...args);
  }

  tag(tag: string) {
    this.push(["tag", tag]);
  }

  custom(object: any) {
    this.push(["custom", object]);
  }
}

export const luckyOrange = new LuckyOrangeClass();

export const LuckyOrange = () => {
  const { isAuthenticated } = useAuth();
  const { isFeatureEnabled, getFeatureConfigValue } = useConfig();

  const [hasConsent, setHasConsent] = useState(getConsentForCategory("analytics"));

  useEffect(() => {
    const handleConsentChange = () => {
      setHasConsent(getConsentForCategory("analytics"));
    };

    window.addEventListener("consentStatusUpdated", handleConsentChange);

    return () => {
      window.removeEventListener("consentStatusUpdated", handleConsentChange);
    };
  }, []);

  useEffect(() => {
    if (!isAuthenticated && isFeatureEnabled(FeatureLuckyOrange) && hasConsent) {
      luckyOrange.initialize(getFeatureConfigValue(FeatureLuckyOrange, FeatureConfigLuckyOrangeSiteId));
    }
  }, [isAuthenticated, hasConsent, isFeatureEnabled, getFeatureConfigValue]);
  return <></>;
};
